/* tslint:disable */
/* eslint-disable */
/**
 * Donio
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiRequestValidationExceptionResponse,
  BadRequestExceptionResponse,
  InitPaymentIntentRequest,
  InitPaymentIntentResponse,
  InternalServerErrorExceptionResponse,
  NotFoundExceptionResponse,
  PaymentIntentStateResponse,
} from '../models/index';
import {
    ApiRequestValidationExceptionResponseFromJSON,
    ApiRequestValidationExceptionResponseToJSON,
    BadRequestExceptionResponseFromJSON,
    BadRequestExceptionResponseToJSON,
    InitPaymentIntentRequestFromJSON,
    InitPaymentIntentRequestToJSON,
    InitPaymentIntentResponseFromJSON,
    InitPaymentIntentResponseToJSON,
    InternalServerErrorExceptionResponseFromJSON,
    InternalServerErrorExceptionResponseToJSON,
    NotFoundExceptionResponseFromJSON,
    NotFoundExceptionResponseToJSON,
    PaymentIntentStateResponseFromJSON,
    PaymentIntentStateResponseToJSON,
} from '../models/index';

export interface GetPaymentIntentStateRequest {
    paymentIntentId: string;
}

export interface PostCreatePaymentIntentRequest {
    initPaymentIntentRequest?: InitPaymentIntentRequest;
}

/**
 * 
 */
export class TrustpayPaymentIntentsApi extends runtime.BaseAPI {

    /**
     * Gets TrustPay payment-intent state
     */
    async getPaymentIntentStateRaw(requestParameters: GetPaymentIntentStateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaymentIntentStateResponse>> {
        if (requestParameters['paymentIntentId'] == null) {
            throw new runtime.RequiredError(
                'paymentIntentId',
                'Required parameter "paymentIntentId" was null or undefined when calling getPaymentIntentState().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/donations/payment/trustpay/payment-intent/{paymentIntentId}/state`.replace(`{${"paymentIntentId"}}`, encodeURIComponent(String(requestParameters['paymentIntentId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaymentIntentStateResponseFromJSON(jsonValue));
    }

    /**
     * Gets TrustPay payment-intent state
     */
    async getPaymentIntentState(requestParameters: GetPaymentIntentStateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaymentIntentStateResponse> {
        const response = await this.getPaymentIntentStateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Initiate new TrustPay payment intent
     */
    async postCreatePaymentIntentRaw(requestParameters: PostCreatePaymentIntentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InitPaymentIntentResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/donations/payment/trustpay/payment-intent`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InitPaymentIntentRequestToJSON(requestParameters['initPaymentIntentRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InitPaymentIntentResponseFromJSON(jsonValue));
    }

    /**
     * Initiate new TrustPay payment intent
     */
    async postCreatePaymentIntent(requestParameters: PostCreatePaymentIntentRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InitPaymentIntentResponse> {
        const response = await this.postCreatePaymentIntentRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
